import React from 'react'
import { OrgSwitcher as BaseOrgSwitcher } from '@agion/ui'
import { useOrganization } from '@agion/auth'
import { useOrgSwitcherLabels, useOrganizationErrorMessage } from '@/components/infra_org_switcher_labels'

interface InfraOrgSwitcherProps {
  collapsed?: boolean
}

export const InfraOrgSwitcher: React.FC<InfraOrgSwitcherProps> = ({ collapsed = false }) => {
  const labels = useOrgSwitcherLabels()
  const { active, all, isLoading, errorCode, switchOrg } = useOrganization()
  const error = useOrganizationErrorMessage(errorCode)

  return (
    <BaseOrgSwitcher
      organizations={all}
      currentOrgId={active?.id}
      onSwitch={switchOrg}
      variant="sidebar"
      collapsed={collapsed}
      isLoading={isLoading}
      error={error}
      labels={labels}
    />
  )
}
